{
  "dataUpdatedSuccessfully": {
    "type": "success",
    "header": "Erfolg",
    "body": "Daten wurden erfolgreich aktualisiert."
  },
  "accountCreatedSuccessfully": {
    "type": "success",
    "header": "Erfolg",
    "body": "Konto erfolgreich angelegt."
  },
  "accountUpdatedSuccessfully": {
    "type": "success",
    "header": "Erfolg",
    "body": "Konto erfolgreich aktualisiert."
  },
  "profileUpdatedSuccessfully": {
    "type": "success",
    "header": "Erfolg",
    "body": "Profil erfolgreich aktualisiert."
  },
  "profileCouldNotBeUpdated": {
    "type": "error",
    "header": "Fehler",
    "body": "Profil konnte leider nicht aktualisiert werden."
  },
  "accountDeletedSuccessfully": {
    "type": "success",
    "header": "Success",
    "body": "Konto gelöscht."
  },
  "dataUpdatedWithErrors": {
    "type": "error",
    "header": "Fehler",
    "body": "Daten konnten nicht aktualisiert werden."
  },
  "accountCouldNotBeCreated": {
    "type": "error",
    "header": "Fehler",
    "body": "Konto konnte leider nicht angelegt werden."
  },
  "accountCouldNotBeUpdated": {
    "type": "error",
    "header": "Fehler",
    "body": "Konto konnte leider nicht aktualisiert werden."
  },
  "dataUpdateProblems": {
    "type": "warning",
    "header": "Warnung",
    "body": "Einige Transaktionen könnten leider nicht aktualisiert werden."
  },
  "dataUpdateError": {
    "type": "error",
    "header": "Fehler",
    "body": "Daten konnten leider nicht aktualisiert werden. Bitte überprüfe die Netzwerkverbindung."
  },
  "projectUpdateError": {
    "type": "error",
    "header": "Error",
    "body": "Projekt konnte leider nicht aktualisiert werden. Bitte überprüfe die Netzwerkverbindung."
  },
  "dataUpdateErrorContents": {
    "type": "error",
    "header": "Fehler",
    "body": "Daten konnten leider nicht aktualisiert werden. Bitte überprüfe die Werte des Formulars."
  },
  "checkYourData": {
    "type": "error",
    "header": "Fehler",
    "body": "Änderungen nicht gespeichert. Siehe Zell-Kommentaren."
  },
  "fileUploadAbortedSuccessfully": {
    "type": "success",
    "header": "Erfolg",
    "body": "Datei-Upload storniert. Datei wurde nicht hochgeladen."
  },
  "Error. Request failed with status code 502": {
    "type": "error",
    "header": "Sync fehlgeschlagen",
    "body": "Daten konnten nicht synchronisiert werden. Bitte versuche es in 30 Sekunden noch einmal."
  },
  "surveySendingError": {
    "type": "error",
    "header": "Umfrage konnte nicht geschickt werden",
    "body": "Die Daten konnten nicht übermittelt werden."
  },
  "surveySentSuccessfully": {
    "type": "success",
    "header": "Vielen Dank!",
    "body": "Die Umfrage ist erfolgreich übermittelt worden."
  },
  "transactionNotSelected": {
    "type": "error",
    "header": "Keine Transaktion ausgewählt",
    "body": "Bitte wähle eine Transaktion aus, die die Gebühren verursacht hat."
  },
  "symbolNotSelected": {
    "type": "error",
    "header": "Kein Wertpapier ausgewählt",
    "body": "Bitte wähle ein Wertpapier aus, das die Dividende gezahlt hat."
  },
  "incorrectPassword": {
    "type": "error",
    "header": "Falsches Passwort",
    "body": "Das bisherige Passwort war leider falsch."
  },
  "attemptLimitExceeded": {
    "type": "error",
    "header": "Zu viele Versuche",
    "body": "Wir haben zu viele Passwort-Versuche registriert und aus Sicherheitsgründen diese Funktion temporär gesperrt. Bitte warte 15 Minuten und versuche es dann noch einmal."
  },
  "fileTooLarge": {
    "type": "error",
    "header": "Datei zu groß",
    "body": "Wir können leider nur Dateien kleiner als 5MB verarbeiten."
  },
  "fileUploadError": {
    "type": "warning",
    "header": "Datei-Upload fehlgeschlagen",
    "body": "Einige Dateien konnten nicht hochgeladen werden."
  },
  "noDataForDateFilter": {
    "type": "error",
    "header": "Keine Daten",
    "body": "Für die gewählte Periode gebet es keine Daten. Zurück zur ursprünglich gewählten Periode."
  },
  "applyProjectTemplateSuccess": {
    "type": "success",
    "header": "Erfolg",
    "body": "Vorlage erfolgreich angewendet."
  },
  "applyProjectTemplateError": {
    "type": "error",
    "header": "Fehler",
    "body": "Vorlage konnte nicht angewendet werden."
  },
  "addTransactionManually": {
    "type": "warning",
    "header": "Warning",
    "body": "Kauftransaktion konnte nicht automatisch registriert werden. Bitte füge sie manuell hinzu.",
    "button": "OK",
    "button2": "Cancel"
  },
  "noLinkedAccount": {
    "type": "error",
    "header": "Error",
    "body": "Dein Asset-Konto hat kein verknüpftes Bankkonto. Bitte ergänze dies in der Kontoansicht."
  },
  "errorUpdatingStripe": {
    "type": "error",
    "header": "Emailwechsel unvollständig",
    "body": "Deine E-Mail wurde geändert, aber leider nicht bei unserem Zahlungsdienstleister. Bitte wende dich an unseren Support."
  },
  "existingBankConnectionDetected": {
    "type": "info",
    "header": "Bank-Login bereits vorhanden",
    "body": "Du hast dich bei deiner Bank bereits eingeloggt. Login ist somit nicht mehr erforderlich."
  },
  "newsletterSubscriptionSuccess": {
    "type": "success",
    "header": "Erfolg",
    "body": "Newsletter-Anmeldung erfolgreich."
  },
  "newsletterSubscriptionError": {
    "type": "error",
    "header": "Fehler",
    "body": "Newsletter-Anmeldung fehlgeschlagen."
  },
  "noMoreAccountsAllowed": {
    "type": "error",
    "header": "Fehler",
    "body": "Du hast die maximale Anzahl an Konten des Abos erreicht."
  },
  "inconsistentAssetTransactions": {
    "type": "warninig",
    "header": "Warnung",
    "body": "Anlage-Transaktionen für {{displayName}} in Konto {{accountName}} finden in unterschiedlichen Währungen statt."
  },
  "moreThan1ConnectedAccountFound": {
    "type": "warning",
    "header": "Warnung",
    "body": "Dieses Anlage-Konto ist mit mehr als 1 Bankkonto verbunden."
  },
  "generalError": {
    "type": "error",
    "header": "Fehler",
    "body": "Ein Fehler ist aufgetreten. Bitte versuche es später noch einmal."
  },
  "validationError": {
    "type": "error",
    "header": "Fehler",
    "body": "Daten konnten leider nicht validiert werden."
  },
  "renewAccountAccessSuccess": {
    "type": "success",
    "header": "Erfolg",
    "body": "Kontozugriff erfolgreich erneuert."
  },
  "renewAccountAccessCancelled": {
    "type": "success",
    "header": "Erfolg",
    "body": "Vorgang erfolgreich abgebrochen."
  },
  "renewAccountAccessError": {
    "type": "error",
    "header": "Fehler",
    "body": "Wir konnten den Kontozugriff nicht erneuern. Bitte kontaktiere unseren Support."
  },
  "unableToUpdateAllTransactions": {
    "type": "warning",
    "header": "Warnung",
    "body": "Nicht alle Transaktionen konnten aktualisiert werden."
  }
}
